import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { brandName, heroImage, price, regularPrice, included } from '../data/copy';
import { optimizedImage, optimizedSrcSet } from '../utils/image';
export function OfferSection() {
  return <section id="offer" className="defer-paint w-full scroll-mt-6 bg-ink py-14 sm:py-20" aria-labelledby="offer-heading" data-id="element-143" data-mp="dex3wkczuwdp">
      <div className="mx-auto max-w-6xl px-6" data-id="element-144" data-mp="icymz5af6vp6">
        <div className="mx-auto mb-12 max-w-xl" data-id="element-145" data-mp="meabt8lgzcwb">
          <CountdownTimer data-id="element-146" data-mp="md0ewmqcsar9" />
        </div>

        <div className="mx-auto max-w-xl" data-id="element-147" data-mp="rdem62k4rgo8">
          <div className="min-w-0 rounded-3xl border-2 border-accent/60 bg-panel px-5 py-7 text-center shadow-2xl shadow-fg/10 sm:p-9" data-id="element-148" data-mp="refwu5x8i15f">
            <p className="font-display text-sm font-bold uppercase tracking-[0.22em] text-accent" data-id="element-149" data-mp="2t59jfd5n3imx">
              Your complete access today
            </p>
            <h2 id="offer-heading" className="mt-2 font-display text-[2.2rem] font-extrabold uppercase leading-[0.95] text-fg sm:text-5xl" data-id="element-150" data-mp="2y4w7yiqx4lb1">
              {brandName}
            </h2>

            <img src={optimizedImage(heroImage, 720)} srcSet={optimizedSrcSet(heroImage, [480, 720])} sizes="(min-width: 640px) 340px, 260px" alt="Everything included: 6 visual coaching volumes, the session-plan view and 5 coaching bonuses." className="mx-auto mt-5 w-[260px] sm:w-[340px]" width={1240} height={1240} loading="lazy" decoding="async" data-id="element-151" data-mp="xvqu1vuot8dd" />

            <div className="mt-5 border-t border-line pt-6" data-id="element-152" data-mp="1lk08udthgvv0">
              <p className="text-muted" data-id="element-153" data-mp="1gnt42octpqen">
                Regular price{' '}
                <span className="font-semibold text-fg/80 line-through decoration-danger decoration-2" data-id="element-154" data-mp="1ckwpd8qemefz">{regularPrice}</span>
              </p>
              <p className="mt-4 font-display text-sm font-bold uppercase tracking-[0.22em] text-cta" data-id="element-155" data-mp="17opk7i5u16z3">
                Launch offer
              </p>
              <p className="mt-1 font-display text-[5.5rem] font-extrabold leading-none text-fg sm:text-[7rem]" data-id="element-156" data-mp="3sckmp59by8zb">
                {price}
              </p>
              <p className="mt-2 font-display text-base font-bold uppercase tracking-[0.2em] text-accent" data-id="element-157" data-mp="3trwvh62dvnai">
                One-time payment
              </p>
              <p className="mt-2 text-sm text-muted" data-id="element-158" data-mp="3ks9s4eq3g7et">
                No subscription. Pay in your local currency where available.
              </p>
            </div>

            <div className="mt-6 border-t border-line pt-6 text-left" data-id="element-159" data-mp="3b3rs3zpn24c8">
              <h3 className="text-center font-display text-sm font-bold uppercase tracking-[0.22em] text-muted" data-id="element-160" data-mp="3b1f5h98xr5su">
                What you get
              </h3>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-161" data-mp="316n55xnyy4ud">
                {included.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-fg/90 sm:text-[0.95rem]" data-id="element-162" data-mp="365gi9ozcftu0">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-163" data-mp="2s55rely1af8u" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <CtaButton size="large" className="mt-7 w-full" data-id="element-164" data-mp="2di732zuh40yc">
              Get full access now — {price}
            </CtaButton>

            <p className="mt-4 text-sm text-muted" data-id="element-165" data-mp="2min3u1ju0tzi">
              Secure payment · Instant access · 7-day guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}